export default __webpack_public_path__ + "static/media/extra-time.00400755.svg";